import { IRootState } from '@app/store';

export const selectBasicDataState = (state: IRootState) => state.basicDataState;
